import { createStyles } from '@mantine/core'

export default createStyles((theme) => ({
  control: {
    backgroundColor: theme.white,
  },
}))
